import React, { FC } from "react";
import { Box, Flex, Text, Checkbox } from "@chakra-ui/react";
import { FiEdit2 } from "react-icons/fi";
import { theme } from "@ovou-inc/ovou-ui";
import { ITag } from "../types/Tag";

interface TagListProps {
  tags: ITag[];
  checkedList?: { id: number }[];
  onTagClick: (tag: ITag) => void;
  onCheckboxChange?: (id: number) => void;
  showCheckboxes?: boolean;
  editable: boolean;
}

export const TagList: FC<TagListProps> = ({
  tags,
  checkedList = [],
  onTagClick,
  onCheckboxChange,
  showCheckboxes = false,
  editable,
}) => {
  return (
    <>
      {tags.map((tag: ITag, index: number) => (
        <Flex
          key={tag.id}
          justifyContent="space-between"
          borderBottom={
            index !== tags.length - 1
              ? `1px solid ${theme.palette.ui.greys.grey4}`
              : "none"
          }
          padding="8px"
        >
          <Flex alignItems="center" flex={1}>
            <Box
              width="8px"
              height="8px"
              borderRadius="50%"
              backgroundColor={tag.color}
            />
            <Flex
              flex={1}
              alignItems="center"
              onClick={() => onTagClick(tag)}
              cursor="pointer"
            >
              <Text
                color={theme.palette.brand.primary.black}
                fontSize={14}
                fontWeight="700"
                marginLeft="5px"
              >
                {tag.name}
              </Text>
              {editable && (
                <Box
                  paddingY={3}
                  marginX={2}
                  onClick={e => {
                    e.stopPropagation();
                    onTagClick(tag);
                  }}
                >
                  <FiEdit2
                    color={theme.palette.ui.greys.grey2}
                    cursor="pointer"
                  />
                </Box>
              )}
            </Flex>

            <Text marginRight={3}>{tag.num_contacts}</Text>
            {showCheckboxes && onCheckboxChange && (
              <Checkbox
                isChecked={
                  checkedList.findIndex(item => item.id === tag.id) !== -1
                }
                onChange={() => onCheckboxChange(tag.id)}
                onClick={e => e.stopPropagation()}
              />
            )}
          </Flex>
        </Flex>
      ))}
    </>
  );
};
